import { Iterable } from 'immutable'
import { EMPTY_STR, QUESTION_MARK, AMPERSAND } from '@lacele/const'
import makeQueryParam from '../makeQueryParam'

const makeQueryString = (obj, skipQuestionMark) => {
    if (obj) {
        if (typeof obj === 'string') {
            return obj
        }
        return Object.keys(obj).reduce(
            (urlParams, propName, index) => {
                const urlParam = makeQueryParam(propName, obj[propName])
                if (index === 0) {
                    if (!skipQuestionMark) {
                        return urlParams + QUESTION_MARK + urlParam
                    }
                    return urlParams + urlParam
                }
                return urlParams + AMPERSAND + urlParam
            }, EMPTY_STR)
    }
    return EMPTY_STR
}

export default (obj, skipQuestionMark) => {
    if (Iterable.isIterable(obj)) {
        return makeQueryString(obj.toJS(), skipQuestionMark)
    }
    return makeQueryString(obj, skipQuestionMark)
}
